import React from 'react';

export default function ManagedUserStatusIcon({ type, label }) {
  const paths = {
    enabled: <path d="m5 10.3 3.1 3.1L15.5 6" />,
    disabled: <path d="m6 6 8 8M14 6l-8 8" />,
    admin: <path d="m10 2.8 6 2.3v4.2c0 3.7-2.5 6.6-6 7.9-3.5-1.3-6-4.2-6-7.9V5.1l6-2.3Z M7.3 10.1 9.2 12l3.6-3.7" />,
    projectsAdmin: <path d="M3.5 6.5h5l1.4 1.7h6.6v7.3h-13z M10 10v3M8.5 11.5h3" />,
    projectUser: <><circle cx="8.2" cy="7.2" r="2.4" /><path d="M3.8 16.2c.5-2.7 2.2-4.2 4.4-4.2 1.2 0 2.2.4 3 1.1M13.8 10.4l2.8 2.8M16.6 10.4l-2.8 2.8M15.2 9v5.6" /></>,
    podmanUser: <path d="m10 2.5 6.5 3.8v7.4L10 17.5l-6.5-3.8V6.3L10 2.5Zm-6.5 3.8L10 10l6.5-3.7M10 10v7.5M6.8 4.4l6.5 3.8v3" />,
    group: <><circle cx="7.5" cy="6.5" r="2.5" /><path d="M2.8 16v-1.5a4.7 4.7 0 0 1 9.4 0V16M13 4.2a2.5 2.5 0 0 1 0 4.6M14 11a4.2 4.2 0 0 1 3.2 4V16" /></>
  };
  return <span className={`managed-user-icon ${type}`} role="img" aria-label={label} title={label}><svg viewBox="0 0 20 20" aria-hidden="true">{paths[type] || paths.group}</svg></span>;
}
